export type TrialExhaustedPayload = {
  message?: string;
  limit?: number;
  used?: number;
  /** Plan that hit its cap — paid plans have monthly allowances, not just the trial. */
  plan?: string;
};

/** Detect 403 `trial_exhausted` from API client errors without coupling to ApiError class. */
export function getTrialExhaustedPayload(err: unknown): TrialExhaustedPayload | null {
  if (!err || typeof err !== "object") return null;
  const e = err as { status?: number; data?: unknown };
  if (e.status !== 403) return null;
  const d = e.data as {
    error?: string;
    message?: string;
    limit?: number;
    used?: number;
    plan?: string;
  } | null;
  if (!d || d.error !== "trial_exhausted") return null;
  return {
    message: typeof d.message === "string" ? d.message : undefined,
    limit: typeof d.limit === "number" ? d.limit : undefined,
    used: typeof d.used === "number" ? d.used : undefined,
    plan: typeof d.plan === "string" ? d.plan : undefined,
  };
}
